<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-switch-theme`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.6 26.867a.999.999 0 01.2.2l4 5.333A1 1 0 0113 34h-1.75a8.004 8.004 0 007.482 5.996l.265.004h8a1 1 0 01.994.883l.006.117v2a1 1 0 01-.883.993l-.117.007h-8c-5.945 0-10.881-4.324-11.834-10H5a1 1 0 01-.8-1.6l4-5.333a1 1 0 011.4-.2zM42 4a2 2 0 012 2v25a2 2 0 01-2 2H20a2 2 0 01-2-2V6a2 2 0 012-2h22zm-2 4H22v21h18V8zm-5 13a1 1 0 011 1v2a1 1 0 01-1 1h-8a1 1 0 01-1-1v-2a1 1 0 011-1h8zm0-9a1 1 0 011 1v2a1 1 0 01-1 1h-8a1 1 0 01-1-1v-2a1 1 0 011-1h8z"/></svg>
</template>
<script>

export default {
  name: 'IconSwitchTheme',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
